export default __webpack_public_path__ + "static/media/card_vazio.3bf1b6f6.svg";